import { Subject } from 'rxjs';

export class MockQuicktourService {
  completed$ = new Subject<void>();
  startIntroJS = jasmine.createSpy('startIntroJS');
  setSteps = jasmine.createSpy('setSteps');
  setLabels = jasmine.createSpy('setLabels');
}
